<template>
  <div class="d-flex">
    <b-card
      v-for="(item, index) in summaryItems"
      :key="index"
      class="flex-grow-1 flex-shrink-1 mx-0-5 p-0"
      :body-class="'p-1'"
      :border-variant="item.variant"
    >
      <div class="w-100 text-center mb-0">
        <b-icon :icon="item.icon" :variant="item.variant" class="mr-0-5"></b-icon>
        <b class="fw-bold">{{ item.label }}: {{ formatNumberAndDefault(item.value) }}</b>
      </div>
      <div class="d-flex w-100 mt-0">
        <div
          v-for="(sub, subIndex) in item.subMetrics"
          :key="subIndex"
          class="flex-fill d-flex justify-content-center align-items-center p-0"
        >
          <b class="small">{{ sub.label }}: {{ formatNumberAndDefault(sub.value) }}</b>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios';

import formatNumberWithCommas from '@/xvisor/utilities/addCommaToNumber';

export default {
  props: {
    timeRange: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      zoneUrl: '/security/overview/zonesummary.json',
      serverUrl: '/security/overview/serversummary.json',
      clientUrl: '/security/overview/clientsummary.json',
      endpointUrl: '/security/overview/endpointsummary.json',
      threatUrl: '/security/overview/threatsummary.json',
      zoneData: {},
      serverData: {},
      clientData: {},
      endpointData: {},
      threatData: {},
    };
  },
  mounted() {
    this.httpGet();
  },
  watch: {
    timeRange() {
      this.httpGet();
    },
  },
  computed: {
    httpParams() {
      return {
        params: {
          start: this.timeRange.start.toISOString(),
          end: this.timeRange.end.toISOString(),
        },
      };
    },
    summaryItems() {
      return [
        {
          label: 'Zones',
          value: this.zoneData.total,
          icon: 'b-icon-layers',
          variant: 'primary',
        },
        {
          label: 'Servers',
          value: this.serverData.total,
          icon: 'server',
          variant: 'info',
          subMetrics: [
            { label: 'Enterprise', value: this.serverData.enterprise },
            { label: 'Internet', value: this.serverData.internet },
          ],
        },
        {
          label: 'Clients',
          value: this.clientData.total,
          icon: 'laptop-fill',
          variant: 'success',
          subMetrics: [
            { label: 'Enterprise', value: this.clientData.enterprise },
            { label: 'Internet', value: this.clientData.internet },
          ],
        },
        {
          label: 'Endpoints',
          value: this.endpointData.total,
          icon: 'hdd-fill',
          variant: 'secondary',
        },
        {
          label: 'Threats',
          value: this.threatData.total,
          icon: 'exclamation-triangle-fill',
          variant: 'danger',
          subMetrics: [
            { label: 'Network', value: this.threatData.network },
            { label: 'Endpoint', value: this.threatData.endpoint },
          ],
        },
      ];
    },
  },
  methods: {
    httpGet() {
      this.loaded = false;
      axios
        .all([
          this.$http.get(this.zoneUrl, this.httpParams),
          this.$http.get(this.serverUrl, this.httpParams),
          this.$http.get(this.clientUrl, this.httpParams),
          this.$http.get(this.endpointUrl, this.httpParams),
          this.$http.get(this.threatUrl, this.httpParams),
        ])
        .then(axios.spread((zoneRes, serverRes, clientRes, endpointRes, threatRes) => {
          this.zoneData = zoneRes.data;
          this.serverData = serverRes.data;
          this.clientData = clientRes.data;
          this.endpointData = endpointRes.data;
          this.threatData = threatRes.data;
        }))
        .finally(() => { this.loaded = true; });
    },
    formatNumberAndDefault(value) {
      return formatNumberWithCommas(value ?? 0);
    },
  },
};
</script>
